import React from 'react';
import { StoreMap, stores } from '../components/map/StoreMap';
import { KPICard } from '../components/ui/KPICard';
import { Star, MessageSquare, Store } from 'lucide-react';
export function HeatmapPage() {
  return <div className="flex flex-col h-[calc(100vh-64px)]" data-id="element-487">
      {/* KPI Overlay / Header Area */}
      <div className="px-6 py-6 bg-obi-light z-10" data-id="element-488">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-489">
          <KPICard title="Anzahl Filialen" value={stores.length.toString()} icon={<Store size={18} data-id="element-491" />} data-id="element-490" />
          <KPICard title="Ø Bewertungs-Score" value="4,2" icon={<Star size={18} data-id="element-493" />} data-id="element-492" />
          <KPICard title="Bewertungen gesamt" value="12.482" icon={<MessageSquare size={18} data-id="element-495" />} data-id="element-494" />
        </div>
      </div>

      {/* Map Area */}
      <div className="flex-1 relative border-t border-gray-200" data-id="element-496">
        <StoreMap data-id="element-497" />
      </div>
    </div>;
}